function sendMail() {
		var str=document.getElementById('productdetails').textContent;
		var strcut = str.substring(0, 1000);
        var prodname=document.getElementById('productname').textContent;
   

		var link = "mailto:yourfriend@email.com"
				 + "?subject=" + escape(prodname)
				 + "&body=" + strcut+"...";

		window.open(link,'_blank','width=600,height=600'); 
  
	}

/*
$(window).scroll(function() {
  var scroll = $(window).scrollTop();
	$("#rev_slider .tp-bgimg").css({
		width: (100 + scroll/5)  + "%",
        height: (100 + scroll/5)  + "%",
		top: -(scroll/10)  + "%",
		"-webkit-filter": "blur(" + (scroll/100) + "px)",
		filter: "blur(" + (scroll/100) + "px)"
	});
  
  
 
});
*/


 




jQuery(window).load(function() {
  
 
  
   $( ".product-info .price,.product-info  .total-price " ).each(function() {
   var text = $(this).text().replace("$", "<sup>$</sup>");
    $(this).html(text);
  });
  
  

  
  /*
  $( ".single-option-selector" ).each(function() {
    		$(this).change(function(){ 
              if($(this).val() == 'Vanilla Jasmine'){
				$(this).parent().addClass('vanilla-jasmine');
                $('.collateral ul.tabs.tabs-title').addClass('vanilla-jasmine');
              } else {
                $(this).parent().removeClass('vanilla-jasmine');
                $('.collateral ul.tabs.tabs-title').removeClass('vanilla-jasmine');
              }
              
              if($(this).val() == 'Chamomile & Green Tea'){
				$(this).parent().addClass('chamomile-green-tea');
                $('.collateral ul.tabs.tabs-title').addClass('chamomile-green-tea');
              } else {
                $(this).parent().removeClass('chamomile-green-tea');
                $('.collateral ul.tabs.tabs-title').removeClass('chamomile-green-tea');
              }
              
              if($(this).val() == 'Unscented'){
				$(this).parent().addClass('unscented');
                $('.collateral ul.tabs.tabs-title').addClass('unscented');
              } else {
                $(this).parent().removeClass('unscented');
                $('.collateral ul.tabs.tabs-title').removeClass('unscented');
              }
              
              if($(this).val() == 'Pomegranate'){
				$(this).parent().addClass('pomegranate');
                $('.collateral ul.tabs.tabs-title').addClass('pomegranate');
              } else {
                $(this).parent().removeClass('pomegranate');
                $('.collateral ul.tabs.tabs-title').removeClass('pomegranate');
              }
              
              if($(this).val() == 'Lavender & White Tea'){
				$(this).parent().addClass('lavender-white-tea');
                $('.collateral ul.tabs.tabs-title').addClass('lavender-white-tea');
              } else {
                $(this).parent().removeClass('lavender-white-tea');
                $('.collateral ul.tabs.tabs-title').removeClass('lavender-white-tea');
              }
            });
    
    
    		if($(this).val() == 'Vanilla Jasmine'){
				$(this).parent().addClass('vanilla-jasmine');
                $('.collateral ul.tabs.tabs-title').addClass('vanilla-jasmine');
              } else {
                $(this).parent().removeClass('vanilla-jasmine');
                $('.collateral ul.tabs.tabs-title').removeClass('vanilla-jasmine');
              }
              
              if($(this).val() == 'Chamomile & Green Tea'){
				$(this).parent().addClass('chamomile-green-tea');
                $('.collateral ul.tabs.tabs-title').addClass('chamomile-green-tea');
              } else {
                $(this).parent().removeClass('chamomile-green-tea');
                $('.collateral ul.tabs.tabs-title').removeClass('chamomile-green-tea');
              }
              
              if($(this).val() == 'Unscented'){
				$(this).parent().addClass('unscented');
                $('.collateral ul.tabs.tabs-title').addClass('unscented');
              } else {
                $(this).parent().removeClass('unscented');
                $('.collateral ul.tabs.tabs-title').removeClass('unscented');
              }
              
              if($(this).val() == 'Pomegranate'){
				$(this).parent().addClass('pomegranate');
                $('.collateral ul.tabs.tabs-title').addClass('pomegranate');
              } else {
                $(this).parent().removeClass('pomegranate');
                $('.collateral ul.tabs.tabs-title').removeClass('pomegranate');
              }
              
              if($(this).val() == 'Lavender & White Tea'){
				$(this).parent().addClass('lavender-white-tea');
                $('.collateral ul.tabs.tabs-title').addClass('lavender-white-tea');
              } else {
                $(this).parent().removeClass('lavender-white-tea');
                $('.collateral ul.tabs.tabs-title').removeClass('lavender-white-tea');
              }
    
    
  });
  
  */
  
 
  
 });

jQuery(document).ready(function(){
  
  
  jQuery( ".yotpo.bottomLine.reviews" ).click(function() {
 	jQuery( ".collateral ul.tabs li:nth-child(3)" ).click();
    
    return false;
	});
  
  

  
  /*
   jQuery('[name=id]').change(function() {

    var sku = jQuery(this).find(':selected').attr('data-sku');

    var new_src = jQuery('#preload img[src*=' + sku + ']').attr('src');

    jQuery('.product-single-photos img').attr('src', new_src);
  });
  */
  

     

   jQuery('.single-option-selector').change(function() {
     
          var val= jQuery(this).find('option:selected').text();
     alert(val);
     
          jQuery( ".more-views a.thumb-link" ).each(function() {
            
          });  
            
     
    });
  

  

  
  /*
  // collections page: fade-in item loading :
	window.sr = ScrollReveal({ origin: 'bottom', distance: '200px', delay: 100, scale: 1,easing: 'ease' });
	sr.reveal('.template-collection .col-md-9 .item', { duration: 500 });
*/
  
  
  $( ".price-box" ).each(function() {
   var text = $(this).html().replace("$", "<sup>$</sup>");
    $(this).html(text);
  });
  
  $( ".price-box .boldprice" ).each(function() {
   var text = $(this).html().replace("$", "<sup>$</sup>");
    $(this).html(text);
  });

 
    $('.hpbanner1 .cnt').matchHeight();
  
  $('.landingbanner .eqh').matchHeight();
 
  
  
  $('.slickcarousel').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  accessibility: false,
  responsive: [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
  
  
  
  
   $('.presscarousel').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
     infinite: true,
     adaptiveHeight: true,
  dots: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
  
  
  
  
  	
  
})



function numbersonly(myfield, e, dec)
{
  var key;
  var keychar;

  if (window.event)
    key = window.event.keyCode;
  else if (e)
    key = e.which;
  else
    return true;
  keychar = String.fromCharCode(key);

  // control keys
  if ((key==null) || (key==0) || (key==8) ||
      (key==9) || (key==13) || (key==27) )
    return true;
  // numbers
  else if ((("0123456789").indexOf(keychar) > -1))
    return true;
  else
    return false;
}

/*==================================================
  Accessibility: target="_blank" link warnings
==================================================*/

function enhanceBlankTargetLinks(root = document) {

  if (!document.getElementById('new-window-warning')) {
    var warning = document.createElement('span');
    warning.id = 'new-window-warning';
    warning.textContent = ' Opens in a new tab.';
    warning.className = 'visually-hidden';
    document.body.appendChild(warning);
  }

  root.querySelectorAll('a[target="_blank"]:not([data-a11y-processed])').forEach(function(link) {

    link.setAttribute('data-a11y-processed', 'true');

    var rel = (link.getAttribute('rel') || '').split(/\s+/);

    if (!rel.includes('noopener')) {
      rel.push('noopener');
    }

    if (!rel.includes('noreferrer')) {
      rel.push('noreferrer');
    }

    link.setAttribute('rel', rel.filter(Boolean).join(' '));

    link.setAttribute('aria-describedby', 'new-window-warning');

  });

}


enhanceBlankTargetLinks();


var blankLinkObserver = new MutationObserver(function(mutations) {

  mutations.forEach(function(mutation) {

    mutation.addedNodes.forEach(function(node) {

      if (node.nodeType === 1) {
        enhanceBlankTargetLinks(node);
      }

    });

  });

});


blankLinkObserver.observe(document.body, {
  childList: true,
  subtree: true
});



